<template>
    <b-row class="p-0 m-0">
        <b-col md="4" lg="3" class="training-nav">
            <b-nav vertical>
                <b-nav-text>Topics</b-nav-text>
                <b-nav-item v-for="topic in topics" :key="topic.title">
                    {{ topic.title }}
                    <template v-if="topic.children">
                        <b-nav vertical>
                            <b-nav-item v-for="link in topic.children" :key="link.title">{{ link.title }}</b-nav-item>
                        </b-nav>
                    </template>
                </b-nav-item>
                <b-nav-text>
                    <a href="/contact">Contact Us</a>
                </b-nav-text>
            </b-nav>
        </b-col>
        <b-col class="training-hq">
            <h3 class="text-center text-info">{{ config('app.name') }} Electronic Visit Verification Training HQ</h3>
            <b-row class="mt-4">
                <b-col md="6">
                    <b-card
                            title="Video 1"
                            img-src="https://lorempixel.com/640/480/business/1"
                            img-alt="Training Video"
                            img-bottom>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card
                            title="Video 2"
                            img-src="https://lorempixel.com/640/480/business/2"
                            img-alt="Training Video"
                            img-bottom>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card
                            title="Video 3"
                            img-src="https://lorempixel.com/640/480/business/3"
                            img-alt="Training Video"
                            img-bottom>
                    </b-card>
                </b-col>
                <b-col md="6">
                    <b-card
                            title="Video 4"
                            img-src="https://lorempixel.com/640/480/business/4"
                            img-alt="Training Video"
                            img-bottom>
                    </b-card>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: ['topics'],

        data() {
            return{

            }
        }
    }
</script>

<style lang="scss">
    @import '../../sass/variable';

    .training-hq {
        border-left: solid 1px $dark;
    }

    .training-nav {
        height: 100%;

        .nav {
            .nav-item {
                .nav-link {
                    color: $primary;
                }
            }
        }
    }
</style>
